import { DialogContent } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'

import {
  Modal,
  ModalCloseButton,
  ModalCloseIcon,
  ModalHeader,
  ModalMessage,
  ModalTitle,
} from './styled'

export interface CountryBannedProps {
  className?: string
  handleClose(): void
  handleContinue(): void
  open: boolean
}

export const CountryBannedModal: React.FC<CountryBannedProps> = ({
  className,
  handleClose,
  handleContinue,
  open,
}) => {
  return (
    <Modal
      aria-describedby="scroll-dialog-description"
      aria-labelledby="scroll-dialog-title"
      className={className}
      fullWidth
      maxWidth="xs"
      onClose={handleClose}
      open={open}
    >
      <ModalTitle disableTypography id="scroll-dialog-title">
        <ModalHeader>SHIPPING RESTRICTIONS</ModalHeader>
        <ModalCloseIcon aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </ModalCloseIcon>
      </ModalTitle>
      <DialogContent dividers>
        <ModalMessage variant="body2" gutterBottom>
          We&apos;re currently unable to ship products to the country you&apos;ve selected.
        </ModalMessage>
        <ModalCloseButton color="secondary" onClick={handleContinue} variant="outlined">
          CHANGE SHIPPING ADDRESS
        </ModalCloseButton>
      </DialogContent>
    </Modal>
  )
}
